import type { Media } from '../payload-types'

/**
 * La didascalia di un'immagine COME VA IN PAGINA, dichiarazione AI inclusa.
 *
 * Esiste come funzione, e non come due espressioni inline, perché i punti in cui un'immagine
 * arriva in pagina sono ora DUE — la copertina (<ArticleView>) e le foto dentro il corpo
 * (il converter `upload` di <RichText>, src/components/RichTextConverters.tsx) — e la parte
 * load-bearing non è la didascalia: è la NOTA D'USO su un'immagine generata da un modello
 * (art. 50 Reg. UE 2024/1689). Su un luogo reale e nominato una foto inventata è
 * un'affermazione visiva, ed è la più difficile da smentire per chi legge: se la regola vivesse
 * scritta a mano in due posti, il secondo posto è quello in cui prima o poi manca.
 *
 * `override` è la didascalia SCRITTA NELL'ARTICOLO (per-inserimento, dal nodo Lexical): vince su
 * `media.caption`, che è un campo del FILE e quindi la stessa in ogni articolo che usa quella foto.
 *
 * LA NOTA NON NOMINA PIÙ IL «LUOGO», e non è una limatura di stile: la formulazione precedente
 * («non è una fotografia del luogo») nasceva sul tenant di viaggio, dove ogni immagine ritrae un
 * posto reale. Su un tenant di finanza le immagini sono illustrazioni di un MECCANISMO — una
 * bilancia, una catena di ingranaggi — e lì la vecchia frase dichiarava il falso al contrario:
 * prometteva un luogo che non c'è e lasciava intendere che il resto fosse una fotografia. «Non è
 * una fotografia» è vero su entrambi i tenant e dice esattamente la cosa che l'art. 50 Reg. UE
 * 2024/1689 vuole che il lettore sappia: questo non è un documento, è un'immagine prodotta.
 *
 * Ritorna '' quando non c'è niente da mostrare — il chiamante omette il nodo.
 */
export function imageCaption(
  media: Partial<Pick<Media, 'caption' | 'aiGenerated'>> | null | undefined,
  override?: string | null,
): string {
  const own = override?.trim() || media?.caption?.trim() || ''
  if (!media?.aiGenerated) return own
  // Senza didascalia propria la nota è tutta la didascalia; con una didascalia propria la segue,
  // perché il lettore deve poter attribuire la dichiarazione a QUESTA immagine e non alla pagina.
  //
  // IL SEPARATORE È UN PUNTO, NON UNA LINEATA. La lineata em (—) è uno dei segni con cui un lettore
  // riconosce a colpo d'occhio un testo scritto da un modello: su una testata che pubblica analisi
  // è un costo di credibilità pagato su ogni immagine di ogni articolo. Due frasi separate da un
  // punto dicono la stessa cosa senza quel segnale. Nel ramo con didascalia propria la nota nomina
  // ora anche la generazione AI, che prima restava implicita: è ciò che l'art. 50 chiede di dire.
  return `${own ? `${own}. ` : ''}Immagine generata con AI, non è una fotografia.`
}
